import Jobs from '@/api/jobs'

export default {
  namespaced: true,
  state: {
    coverLetter: '',
    jobId: '',
    application: '',
    signupBoard: true
  },
  getters: {
    returnedApplication: state => state.application
  },
  mutations: {
    setCoverLetter (state, coverLetter) {
      state.coverLetter = coverLetter
    },
    setOptIn (state, optIn) {
      state.optIn = optIn
    },
    setJobId (state, jobId) {
      state.jobId = jobId
    },
    setApplication (state, application) {
      state.application = application
    },
    clear (state) {
      state.jobId = ''
      state.application = ''
      state.coverLetter = ''
      state.setSignupBoard = ''
    },
    setSignupBoard (state, signupBoard) {
      state.signupBoard = signupBoard
    }
  },
  actions: {
    async apply ({ commit, state }) {
      const application = await Jobs.apply({
        jobId: state.jobId, coverLetter: state.coverLetter, signupBoard: state.signupBoard
      })
      commit('setApplication', application)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/application-form.js